export default function BrandMark({ inverse = false, className = '' }) {
  const color = inverse ? '#FCF8F3' : '#333B29';

  return (
    <svg
      className={className}
      viewBox="0 0 232 45"
      role="img"
      aria-label="Lexi and James"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <text
        x="1"
        y="39"
        fill={color}
        fontFamily="'Newsreader Variable', Georgia, serif"
        fontSize="42"
        fontWeight="560"
      >
        Lexi
      </text>
      <text
        x="87"
        y="37"
        fill={color}
        fontFamily="'Newsreader Variable', Georgia, serif"
        fontSize="26"
        fontStyle="italic"
        fontWeight="430"
      >
        &amp;
      </text>
      <text
        x="118"
        y="39"
        fill={color}
        fontFamily="'Newsreader Variable', Georgia, serif"
        fontSize="42"
        fontWeight="560"
      >
        James
      </text>
    </svg>
  );
}
